import React, { useState } from "react";
import api from "../lib/api";
import { useAuth } from "../lib/auth";
import { useToast, toastErrorMessage } from "../lib/toast";

export default function Settings() {
  const { user } = useAuth();
  const toast = useToast();
  const [cur, setCur] = useState("");
  const [n1, setN1] = useState("");
  const [n2, setN2] = useState("");
  const [msg, setMsg] = useState("");
  const [err, setErr] = useState("");
  async function onSubmit(e) {
    e.preventDefault(); setErr(""); setMsg("");
    if (n1 !== n2) { setErr("New passwords do not match"); return; }
    try {
      await api.post("/auth/change-password", { current_password: cur, new_password: n1 });
      setMsg("Password updated.");
      toast.success("Password updated");
      setCur(""); setN1(""); setN2("");
    } catch(e) {
      const m = toastErrorMessage(e);
      setErr(m); toast.error(m);
    }
  }
  return (
    <div className="max-w-lg space-y-6" data-testid="settings-page">
      <h1 className="text-2xl font-bold">Settings</h1>
      <div className="cesco-card p-5">
        <h3 className="font-semibold">Account</h3>
        <div className="text-sm text-gray-600 mt-1">
          <div>{user?.name}</div>
          <div>{user?.email}</div>
          <div className="mt-1"><span className={`pill ${user?.role === "admin" ? "pill-green" : "pill-blue"}`}>{user?.role}</span></div>
        </div>
      </div>
      <form onSubmit={onSubmit} className="cesco-card p-5 space-y-3">
        <h3 className="font-semibold">Change password</h3>
        <input className="cesco-input" type="password" placeholder="Current password" value={cur}
               onChange={e=>setCur(e.target.value)} required data-testid="settings-current-pw"/>
        <input className="cesco-input" type="password" placeholder="New password (min 8 chars)" value={n1}
               onChange={e=>setN1(e.target.value)} required data-testid="settings-new-pw"/>
        <input className="cesco-input" type="password" placeholder="Confirm new password" value={n2}
               onChange={e=>setN2(e.target.value)} required data-testid="settings-new-pw2"/>
        {msg && <div className="text-sm text-green-700" data-testid="settings-msg">{msg}</div>}
        {err && <div className="text-sm text-red-600">{err}</div>}
        <button className="cesco-btn-primary" data-testid="settings-submit">Update password</button>
      </form>
    </div>
  );
}
